// IE必须加es6-promise/lib/polyfill
// TODO 异步加载
// require('es6-promise').polyfill()
import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import {modules, state, getters, actions} from './store.js'

Vue.use(Vuex)
Vue.config.debug = state.debug

export default new Vuex.Store({
  strict: state.debug,
  plugins: state.debug
    ? [createLogger()]
    : [],
  modules,
  state,
  getters,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js